export var MAX_FIRMOGRAPHICS_ALLOWED = 500000;
export var MAX_FIRMOGRAPHICS_ALLOWED_WIZARD = 500000;
export var SicCodeLevel;
(function (SicCodeLevel) {
    SicCodeLevel["SIC1"] = "SIC1";
    SicCodeLevel["SIC2"] = "SIC2";
    SicCodeLevel["SIC3"] = "SIC3";
    SicCodeLevel["SIC4"] = "SIC4";
})(SicCodeLevel || (SicCodeLevel = {}));
export var NaicsCodeLevel;
(function (NaicsCodeLevel) {
    NaicsCodeLevel["NAICS2"] = "NAICS2";
    NaicsCodeLevel["NAICS3"] = "NAICS3";
    NaicsCodeLevel["NAICS4"] = "NAICS4";
    NaicsCodeLevel["NAICS5"] = "NAICS5";
    NaicsCodeLevel["NAICS6"] = "NAICS6";
})(NaicsCodeLevel || (NaicsCodeLevel = {}));
export var FirmoType;
(function (FirmoType) {
    FirmoType["COUNTRY"] = "country";
    FirmoType["EMPLOYEE_RANGE"] = "employeerange";
    FirmoType["REVENUE_RANGE"] = "revenuerange";
    FirmoType["STATE"] = "state";
    FirmoType["NAICS"] = "naics";
    FirmoType["COMPANY"] = "company";
    FirmoType["ZIP"] = "zip";
    FirmoType["INTENTSIFY_INDUSTRY"] = "intentsify_industry";
})(FirmoType || (FirmoType = {}));
//# sourceMappingURL=Firmographics.js.map